import type { SalesDashboardDateRangeInputValue } from "./SalesDashboardDateRangeInputs";

type SalesDashboardDateRangeValidationError =
  | "dateTimeRangeRequired"
  | "startDateTimeRequired"
  | "endDateTimeRequired"
  | "startDateTimeAfterEndDateTime";

export const getSalesDashboardDateRangeValidationError = ({
  startDateTime,
  endDateTime,
}: SalesDashboardDateRangeInputValue):
  | SalesDashboardDateRangeValidationError
  | undefined => {
  if (!startDateTime && !endDateTime) {
    return "dateTimeRangeRequired";
  }

  if (!startDateTime) {
    return "startDateTimeRequired";
  }

  if (!endDateTime) {
    return "endDateTimeRequired";
  }

  if (startDateTime > endDateTime) {
    return "startDateTimeAfterEndDateTime";
  }

  return undefined;
};
